import React, { useEffect, useState } from "react";

import { Input } from "../../inputs";
import { useInput } from "../../../../shared/hooks/form-fields";

const BrowseTab = (props) => {
    const [displayOptions, setDisplayOptions] = useState([]);
    const filterInput = useInput("");

    useEffect(() => {
        setDisplayOptions(props.options.filter((o) => o.description.toLowerCase().includes(filterInput.value.toLowerCase())));
    }, [filterInput.value, props.options]);

    const addTempSelection = (sel) => {
        props.addTempSelection(sel);
    };

    const options = displayOptions.map((o) => {
        return (
            <li key={o.cxHId}>
                <button
                    className="button -text"
                    onClick={() => {
                        addTempSelection(o);
                    }}
                >
                    {o.description}
                </button>
            </li>
        );
    });

    return (
        <div className="tab-browse">
            <Input {...filterInput.bind} autoFocus={true} placeholder="Filter" />
            <ul className="options-list">{options}</ul>
        </div>
    );
};

export default BrowseTab;
